import Crud from '../views/TipoUnidadeSaude/Crud'
import Entity from '../views/TipoUnidadeSaude/Add'

let routes = {
    path: '/tipo_unidade_saude',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_unidade_saude/add',
            name: 'NovoUnidade',
            component: Entity
        },
        {
            path: '/tipo_unidade_saude/edit/:id?',
            name: 'EditarUnidade',
            component: Entity
        },
        {
            path: '/tipo_unidade_saude',
            name: 'list-tipo-unidade-saude',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Unidades de Saúde',
                breadcrumb: [
                    {
                        text: 'Tipos Unidades de Saúde',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
